// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./vuex/store";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueLuckyCanvas from "@lucky-canvas/vue";
Vue.use(VueLuckyCanvas);
import { authUrl } from "@/utils/jump";
// import VConsole from "vconsole";
// const vConsole = new VConsole();
// Vue.use(vConsole);

import Cookie from "js-cookie";
Vue.use(Cookie);
import animated from "animate.css/animate.css";
Vue.use(animated);
import "./assets/icon/iconfont.css";
import "./assets/css/main.css";
import "./assets/css/product.css";
import "@/assets/font/font.css";
import {
  Col,
  Row,
  Form,
  Button,
  Field,
  Toast,
  Overlay,
  Dialog,
  Checkbox,
  Icon,
  ActionSheet,
  Loading,
  Picker,
  Uploader,
  RadioGroup,
  Radio,
  Popup,
  Lazyload,
  Cascader,
  Image as VanImage
} from "vant";

Vue.use(Lazyload);
Vue.use(Popup);
Vue.use(Col);
Vue.use(Loading);
Vue.use(Checkbox);
Vue.use(VanImage);
Vue.use(Row);
Vue.use(Form);
Vue.use(Button);
Vue.use(Field);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Overlay);
Vue.use(Icon);
Vue.use(Picker);
Vue.use(Uploader);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(ActionSheet);
Vue.use(Cascader);

Vue.use(VueAwesomeSwiper);
Vue.config.ignoredElements = ["wx-open-launch-weapp"];
Vue.config.productionTip = false;

Vue.prototype.ModalHelper = (function(bodyCls) {
  var scrollTop;
  return {
    afterOpen: function() {
      scrollTop = document.scrollingElement.scrollTop;
      document.body.classList.add(bodyCls);
      document.body.style.top = -scrollTop + "px";
    },
    beforeClose: function() {
      // document.scrollingElement.scrollTop = scrollTop;
      document.body.classList.remove(bodyCls);
      document.body.style.top = 0;
      // scrollTop lost after set position:fixed, restore it back.
    }
  };
})("dialog-open");
Vue.config.devtools = true;

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  var UrlObject = to.query; //获取当前页面传过来的参数
  if (UrlObject.wxid == 1) {
    // localStorage.setItem("wx_openid", "o2xjis0zNHUCn26VzrEBUbAaKKec");
    localStorage.setItem("wx_openid", "oLpaZv47Ql8WX40QOsz3Ct0W-Eog");
    //o2xjis-hs4KP2LToEg7n7GwczM_0 prd wxid
    // localStorage.setItem("wx_openid", "oLpaZvxgLcSJa1GiGF1_QBdIGa4I");//安卓测试手机
    localStorage.setItem("wx_token", "C99DDDD743636453DA8A864EA23DA6816");
    let User = {};
    let Headimgurl = "";
    let Nickname = "";
    if (User) {
      Headimgurl = "";
      Nickname = "";
    }
    localStorage.setItem("wx_mp", JSON.stringify(User));
    window.location.replace(process.env.host_url + "#" + to.fullPath);
  }
  const token = localStorage.getItem("wx_token");
  if (!token) {
    authUrl();
  } else {
    next();
  }
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js